import { defineMessage } from 'react-intl';

export const paymentCommonI18n = {
  /* Payment status */
  partially_refunded: defineMessage({
    id: 'common:payment.partially-refunded',
    defaultMessage: 'Partially refunded'
  }),
  refunded: defineMessage({
    id: 'common:payment.refunded',
    defaultMessage: 'Refunded'
  }),
  succeeded: defineMessage({
    id: 'common:payment.succeeded',
    defaultMessage: 'Succeeded'
  }),

  /* Misc */
  free: defineMessage({
    id: 'common:payment.free',
    defaultMessage: 'Free'
  }),
  perMonthShort: defineMessage({
    id: 'common:payment.per-month-short',
    defaultMessage: '/month'
  }),
  perYearShort: defineMessage({
    id: 'common:payment.per-year-short',
    defaultMessage: '/year'
  })
};
